// extracted by css-extract-rspack-plugin
export default {"confluenceIcon":"XVMYQjLUQQDx9_tY","confluenceButton":"bXTAcStY2pcPGIeD","confluenceModalBody":"nRHrj00q4VsuK9cB"};